import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side" }
const _hoisted_2 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_3 = { slot: "bottom-sheet-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_6 = { class: "profile-creation-wizard__side-description" }
const _hoisted_7 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {useTranslation} from '@malt/vue3-use';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'YourExperienceSide',
  setup(__props) {

    const {msg} = useTranslation();

return (_ctx: any,_cache: any) => {
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_bottom_sheet, {
        id: "completion-your-experience-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.title')), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.line.01')), 1),
            _hoisted_4,
            _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.line.02')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "profile-creation-wizard__side-container profile-creation-wizard__side-container",
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_joy_icon, {
              name: "freelancer-placeholder",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.title')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.line.01')), 1),
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.line.02')), 1)
        ])
      ], 4)
    ])
  ]))
}
}

})